import type { CrudConfig } from '@/components/GenericCrudPage';

/**
 * 监考事件日志 — 只读.
 */
export const proctorConfig: CrudConfig = {
  resource: 'proctor',
  title: '监考日志',
  rowKey: 'id',
  searchFields: ['event_type', 'severity'],
  disableCreate: true,
  disableEdit: true,
  disableDelete: true,
  fields: [
    { name: 'id', label: 'ID', type: 'readonly', width: 80, readonly: true },
    { name: 'participant_id', label: '考生 ID', type: 'number', width: 100, readonly: true },
    { name: 'session_id', label: '场次 ID', type: 'number', width: 100, readonly: true },
    {
      name: 'event_type',
      label: '事件类型',
      type: 'select',
      width: 160,
      readonly: true,
      options: [
        { label: '页面切换', value: 'TAB_SWITCH', color: 'orange' },
        { label: '失焦', value: 'BLUR', color: 'gold' },
        { label: '退出全屏', value: 'EXIT_FULLSCREEN', color: 'orange' },
        { label: '复制粘贴', value: 'COPY_PASTE', color: 'red' },
        { label: '右键菜单', value: 'CONTEXT_MENU' },
        { label: '截屏', value: 'SCREENSHOT' },
        { label: '断网重连', value: 'RECONNECT', color: 'blue' },
        { label: '心跳超时', value: 'HEARTBEAT_TIMEOUT', color: 'red' },
        { label: '其他', value: 'OTHER' },
      ],
    },
    {
      name: 'severity',
      label: '严重程度',
      type: 'select',
      width: 120,
      readonly: true,
      options: [
        { label: '信息', value: 'INFO', color: 'blue' },
        { label: '警告', value: 'WARN', color: 'orange' },
        { label: '严重', value: 'CRITICAL', color: 'red' },
      ],
    },
    { name: 'detail', label: '详情', type: 'json', hideInTable: true, readonly: true },
    { name: 'created_at', label: '发生时间', type: 'datetime', width: 180, readonly: true },
  ],
};
